<template>
  <div class="pages">

    <div class="footer" @scroll="scrollT($event)" ref="foote">
      <div class="navImage">
        <img v-if="guangao.pc_file_type == 'image'" :src="guangao.pc_file_path" alt=""> <!--  -->
       <video v-if="guangao.pc_file_type == 'video' && count == '0'" style="width: 100%;height: 100%;":src="guangao.pc_file_path"  autoplay="autoplay" :controls="false"
    ></video>
      <!--  <div class="nav_title">
          <span>2020大展</span>
        </div>
        <div class="line"></div>
        <div class="titl">
          <span>守正创新</span>
        </div>
        <div class="nav_content">
          <span>
            摄影从来就是一种观念的表达,是从具象到“抽象”的过程。它将世界抽象化为一个具体的戏剧性的片段,或者说,瞬间。这使得“众创”成为某种可能。
            <br />
            因为艺术创作的私密性与孤独性,即便是那些充满理性的、宏大叙事的作品,也只是描摹出创作者的私人轨迹,跟随着历史的脉络。
          </span>
        </div> -->
      </div>
      <div class="listA">
            <div class="ig" v-if="listTab.length <= 0">
                <img v-if="lang == 'cn'" src="../assets/image/closea.png" alt="">
                  <img v-else src="../assets/image/closeaE.png" alt="">
            </div>

            <div v-else>
                <div class="listcom" v-if="index%2 == 0" v-for="(item,index) in listTab" :key="index" @click="exhibitionDetail(item.id,item.title,index)">
                      <div class="iconImage">
                        <img :src="item.img_src" alt="">
                      </div>
                      <div class="iconRight">
                        <div class="iconTitle">
                          <div>
                            <span>{{item.title}}</span>
                          </div>
                          <div class="icon_right">
                            <img src="../assets/image/right.png" alt="">
                          </div>
                        </div>
                        <div class="icon_T">
                          <span>{{item.description}}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="listcom" @click="exhibitionDetail(item.id,item.title,index)">

                      <div class="iconRight">
                        <div style="float: right;">
                          <div class="iconOdd">
                            <div class="icon_right" style="margin-right: 8px;">
                              <img src="../assets/image/left.png" alt="">
                            </div>
                            <div>
                              <span>{{item.title}}</span>
                            </div>

                          </div>
                          <div class="clear"></div>
                          <div class="icon_T">
                            <span>{{item.description}}</span>
                          </div>
                        </div>


                      </div>
                      <div class="iconImage">
                        <img :src="item.img_src" alt="">
                      </div>

                </div>
            </div>

          <fiex :shows="fixed" :fatherMethod="goTop" >

          </fiex>
        <div class="clear"></div>
         <div style="height: 100px;"></div>

      </div>
     <div class="footerTitle">
        <div class="title_center">
		<div class="listB" style="padding-top: 4px;padding-bottom: 4px;">
			<a href='https://218.26.86.27:8067/ei/Ei!certificate.action?id=9028ffb17604406e01761864b3aa0010' target='_blank' style='border:0;height: 59px;'><img src='../assets/image/shichang.png' style='border:0;height: 100%;width: 100%;'/></a>
		</div>
          <div class="listB">
            <span>{{$t('language.address_b')}}：{{address}}</span>
          </div>
          <div class="listB" v-if="email">
            <span>{{$t('language.emails')}}:{{email}}</span>
          </div>
          <div class="listB">
            <span>ICP备：晋ICP备13002558号-2</span>
          </div>
		  
        </div>
      </div>
    </div>

  </div>
</template>

<script>
    import fiex from '../components/fiex.vue'
  export default {
    components:{
      fiex
    },
    data() {
      return {
        address:'',
        email:'',
        isIndex:true,
        fixed:false,
        footerShow:false,
        images: require('../assets/image/banner1.png'),
        imageUrl: require('../assets/image/newsBanner.png'),
        listTab: [],
        guangao:{},
        playerOptions: {
          playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: "",
            src: 'http://shoot.pingyao888.cn/uploads/20200729/202007291922539108b9627.mp4' //url地址
          }],
          poster: "", //你的封面地址
          // width: document.documentElement.clientWidth,
          notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true, //当前时间和持续时间的分隔符
            durationDisplay: true, //显示持续时间
            remainingTimeDisplay: false, //是否显示剩余时间功能
            fullscreenToggle: true //全屏按钮
          }
        },
        lang:'cn'
      }
    },


    created() {
      if(localStorage.getItem('languageSet') == 'zh'){
        this.lang = 'en'
      }else{
        this.lang = 'cn'
      }
      this.$fetch('/Hall/displayCategoryList').then(res => {
        console.log(res);
        this.listTab = res.data;
      })
      var data = {
        location:2
      }
      this.$fetch('/ad/fixed',data).then(res=>{
        console.log(res);
        this.guangao = res.data;
      })
      this.$fetch('/index/info').then(res=>{
        this.address = res.data.address;
        this.email = res.data.email;
      })
    },
    mounted(){

    },
    computed:{
       count(){
         return this.$store.store.state.count
       },
    },
    methods: {
      goTop(){
        this.$refs.foote.scrollTop = 0;
      },
      scrollT(event){
        var that = this;
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || that.$refs.foote.scrollTop ||
          window.pageYOffset;
          if(scrollTop > 20){
            that.fixed = true;
          }else{
            that.fixed = false;
          }
         let scrollBottom =
           event.target.scrollHeight -
           event.target.scrollTop -
           event.target.clientHeight;
           if(scrollBottom <=0){
             this.footerShow = true;
           }else{
             this.footerShow = false;
           }

      },
      exhibitionDetail(id, title,index) {
        this.$router.push({
          path: '/halldetail',
          query: {
            display_category_id: id,
            title: title,
            index:index
          }
        })
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/exhibition.css");
</style>



// WEBPACK FOOTER //
// src/pages/exhibition.vue